// ── 이번달 계약 데스크탑 표 (2026-06-07 분리) ──────────────────────────────
import React, { useMemo } from 'react';
import { cn } from '../../../../lib/utils';
import { buildColumns, fmt, metricValue, sumRows } from './helpers';

export function ContractTable({ rows, nameLabel, productColumns, categoryColumns }) {
  const columns = useMemo(
    () => buildColumns(productColumns, categoryColumns),
    [productColumns, categoryColumns],
  );
  const sum = useMemo(() => sumRows(rows, columns), [rows, columns]);

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse text-[7px]">
        <thead className="sticky top-0 z-10">
          <tr>
            <th className="text-[7px] px-1 py-0.5 text-left font-bold text-[var(--text)] border-b-2 border-[var(--border)] bg-slate-50 dark:bg-pine-800/40 whitespace-nowrap min-w-[40px]">{nameLabel}</th>
            {columns.map((column) => (
              <th
                key={column.key}
                className={cn(
                  'text-[7px] px-0.5 py-0.5 text-right font-bold border-b-2 border-[var(--border)] bg-slate-50 dark:bg-pine-800/40 whitespace-nowrap',
                  column.bold ? 'text-indigo-600 dark:text-indigo-400' : column.accent ? 'text-emerald-600 dark:text-emerald-400' : 'text-[var(--text)]',
                )}
              >
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={columns.length + 1} className="py-3 text-center text-[var(--text-muted)]">데이터 없음</td>
            </tr>
          ) : rows.map((row) => (
            <tr key={row.name} className="hover:bg-slate-50 dark:hover:bg-pine-800/30">
              <td className="px-1 py-0.5 font-bold text-[var(--text)] border-b border-[var(--border)] whitespace-nowrap">{row.name}</td>
              {columns.map((column) => (
                <td
                  key={column.key}
                  className={cn(
                    'px-0.5 py-0.5 text-right border-b border-[var(--border)] whitespace-nowrap tabular-nums',
                    column.bold ? 'font-black text-indigo-600 dark:text-indigo-400' : column.accent ? 'font-bold text-emerald-600 dark:text-emerald-400' : 'text-[var(--text)]',
                  )}
                >
                  {fmt(metricValue(row, column))}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
        {rows.length > 0 && (
          <tfoot>
            <tr className="bg-indigo-50 dark:bg-indigo-900/20">
              <td className="px-1 py-0.5 font-black text-indigo-600 dark:text-indigo-400 border-t-2 border-[var(--border)] whitespace-nowrap">합계</td>
              {columns.map((column) => (
                <td
                  key={column.key}
                  className={cn(
                    'px-0.5 py-0.5 text-right font-black border-t-2 border-[var(--border)] whitespace-nowrap tabular-nums',
                    column.bold ? 'text-indigo-600 dark:text-indigo-400' : column.accent ? 'text-emerald-600 dark:text-emerald-400' : 'text-[var(--text)]',
                  )}
                >
                  {fmt(sum[column.key])}
                </td>
              ))}
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
}
